
import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

interface ScrollingTextProps {
  text: string;
  maxLines?: number;
  scrollInterval?: number;
  className?: string;
}

export const ScrollingText: React.FC<ScrollingTextProps> = ({
  text,
  maxLines = 3,
  scrollInterval = 3000,
  className
}) => {
  const [currentStart, setCurrentStart] = useState(0);
  
  // Split text into words and group into lines that fit
  const words = text.split(' ');
  const lines: string[] = [];
  
  // Simple line breaking - could be enhanced with actual text measurement
  let currentLine = '';
  const maxWordsPerLine = Math.max(5, Math.floor(50 / Math.max(1, words.length / 10)));
  
  words.forEach((word, index) => {
    if (currentLine.length === 0) {
      currentLine = word;
    } else if (currentLine.split(' ').length < maxWordsPerLine) {
      currentLine += ' ' + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });
  
  if (currentLine) {
    lines.push(currentLine);
  }

  // Auto-scroll if text is longer than maxLines
  useEffect(() => {
    if (lines.length <= maxLines) return;

    const interval = setInterval(() => {
      setCurrentStart(prev => {
        const nextStart = prev + maxLines;
        return nextStart >= lines.length ? 0 : nextStart;
      });
    }, scrollInterval);

    return () => clearInterval(interval);
  }, [lines.length, maxLines, scrollInterval]);

  const visibleLines = lines.slice(currentStart, currentStart + maxLines);

  return (
    <div className={cn("transition-all duration-500 ease-in-out", className)}>
      {visibleLines.map((line, index) => (
        <div
          key={`${currentStart}-${index}`}
          className="animate-fade-in leading-relaxed"
        >
          {line}
        </div>
      ))}
    </div>
  );
};
